import { FunctionComponent, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { makeStyles, mergeClasses } from '@griffel/react'
import { tokens } from '@fluentui/tokens'
import { IFilter } from '@knowmax/genericlist-core'
import { Filter } from '.'

const useClasses = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM
  }
})

/** Renders list of filters. */
export const FilterList: FunctionComponent<{ list: IFilter[], listId?: string, className?: string }> = observer(({ list, listId, className }) => {
  const classes = useClasses()

  const visiblelist = useMemo(() => list.filter((filter) => filter.hidden !== true), [list])

  return (
    <div className={mergeClasses(classes.root, className)}>
      {visiblelist.map((filter) => <Filter key={filter.id} filter={filter} listId={listId} />)}
    </div>
  )
})